export default {
      id: "ic_tel-usage",
      viewBox: "0 0 20 20",
      url: "../dist/images/" + "sprite.svg#ic_tel-usage",
      toString: function () {
        return this.url;
      }
    }